import { getTempImageUrl } from '@/api/aics/image';
// 解析块格式流程图（完整实现）
function parseBlockFlowchart(content) {
  const flowContent = content.replace(/\[flowchart\]|\[\/flowchart\]/g, '').trim();
  const lines = flowContent.split('\n');
  const nodes = [];
  const edges = [];
  let title = '流程图';
  //let nodeId = 1;

  lines.forEach(line => {
    line = line.trim();
    if (!line) return;

    // 解析标题
    if (line.startsWith('title:')) {
      title = line.replace('title:', '').trim();
      return;
    }

    // 解析节点: (id)=>描述 或 [id]=>描述
    if (line.includes('=>')) {
      const [left, right] = line.split('=>').map(part => part.trim());
      let type, id;

      if (left.startsWith('(') && left.endsWith(')')) {
        type = 'startend';
        id = left.slice(1, -1);
      } else if (left.startsWith('[') && left.endsWith(']')) {
        type = 'process';
        id = left.slice(1, -1);
      } else {
        type = 'node';
        id = left;
      }

      nodes.push({ id, type, description: right });
      return;
    }

    // 解析边: (源节点)->(目标节点)
    if (line.includes('->')) {
      const [source, target] = line.split('->').map(part => {
        part = part.trim();
        // 移除括号
        if (part.startsWith('(') && part.endsWith(')')) {
          return part.slice(1, -1);
        }
        return part;
      });
      edges.push({ source, target });
    }
  });

  return generateBlockFlowchartHTML(title, nodes, edges);
}

// 解析行格式流程图
// 解析行格式流程图（完整实现）
/*
function parseInlineFlowchart(content) {
  console.log('解析行格式流程图:', content);

  // 提取标题
  const titleMatch = content.match(/【([^】]+)】/);
  const title = titleMatch ? titleMatch[1] : '业务流程';

  // 提取步骤
  const steps = content.replace(/【[^】]+】/, '').split('→').map(step => step.trim());

  // 使用紧凑型布局
  return generateCompactFlowchartHTML(title, steps);
}

// 生成简单流程图的HTML
function generateSimpleFlowchartHTML(title, steps) {
  return `
    <div class="simple-flowchart-container">
      <div class="flowchart-title">${title}</div>
      <div class="flowchart-steps">
        ${steps.map((step, index) => `
          <div class="flow-step">
            <div class="step-number">${index + 1}</div>
            <div class="step-content">${step}</div>
            ${index < steps.length - 1 ? '<div class="step-arrow">→</div>' : ''}
          </div>
        `).join('')}
      </div>
    </div>
  `;
}
  */
// 生成块格式流程图的HTML
function generateBlockFlowchartHTML(title, nodes, edges) {
  return `
    <div class="block-flowchart-container">
      <div class="flowchart-title">${title}</div>
      <div class="flowchart-nodes">
        ${nodes.map(node => `
          <div class="flow-node flow-node-${node.type}" data-node-id="${node.id}">
            <span class="node-label">${node.id}</span>
            <div class="node-description">${node.description}</div>
          </div>
        `).join('')}
      </div>
      <div class="flowchart-edges">
        ${edges.map(edge => `
          <div class="flow-edge" data-from="${edge.source}" data-to="${edge.target}">
            <div class="edge-arrow"></div>
          </div>
        `).join('')}
      </div>
    </div>
  `;
}
// 新增：生成紧凑型流程图的HTML（专为聊天窗口设计）
function generateCompactFlowchartHTML(title, steps) {
  return `
    <div class="compact-flowchart-container">
      <div class="compact-flowchart-title">${title}</div>
      <div class="compact-flowchart-steps-wrapper">
        <div class="compact-flowchart-steps">
          ${steps.map((step, index) => `
            <div class="compact-flow-step">
              <div class="compact-step-number">${index + 1}</div>
              <div class="compact-step-content">${step}</div>
              ${index < steps.length - 1 ? '<div class="compact-step-arrow">→</div>' : ''}
            </div>
          `).join('')}
        </div>
      </div>
      ${steps.length > 4 ? `
        <div class="compact-scroll-hint">
          <svg viewBox="0 0 24 24">
            <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
          </svg>
          左右滑动（选中流程图，左右箭头）查看更多
        </div>
      ` : ''}
    </div>
  `;
}
export const BASE_PROCESSORS = {
  systemMessage: content => {
    // 检测是否为系统结束消息
    const systemEndPattern = /\(type:\s*['"]CONVERSATION_TIMEOUT['"][\s\S]*?\)/;
    return content.replace(systemEndPattern, (match) => {
      console.log('检测到系统结束消息，保持原样:', match);
      return match; // 保持原样，不进行转义处理
    });
  },  
  table: content => {
    console.log('表格处理器输入（原始内容）:', content);

    return content.replace(/^([|]?.+?[|].+)(?:\n[|]?.+?[|].+)*$/gm, (tableBlock) => {
      console.log('匹配到表格块:', tableBlock);

      const rows = tableBlock.trim().split('\n');
      console.log('分割后的行:', rows);

      if (rows.length < 2) {
        console.log('行数不足，不是有效表格');
        return tableBlock;
      }

      // 解析表头
      const headerCells = rows[0].split('|').filter(cell => cell.trim() !== '');
      console.log('表头单元格:', headerCells);

      if (headerCells.length === 0) {
        console.log('没有表头单元格');
        return tableBlock;
      }

      // 解析分隔线（第二行）以确定对齐方式
      const separatorRow = rows[1].split('|').filter(cell => cell.trim() !== '');
      console.log('分隔线行:', separatorRow);

      const alignments = separatorRow.map(cell => {
        const content = cell.trim();
        if (content.startsWith(':') && content.endsWith(':')) {
          console.log(`单元格 "${content}" 居中对齐`);
          return 'center';
        }
        if (content.endsWith(':')) {
          console.log(`单元格 "${content}" 右对齐`);
          return 'right';
        }
        console.log(`单元格 "${content}" 左对齐`);
        return 'left';
      });

      console.log('对齐方式数组:', alignments);

      // 构建表格HTML
      let tableHtml = '<div class="markdown-table-container"><table class="markdown-table">';

      // 添加表头
      tableHtml += '<thead><tr>';
      headerCells.forEach((cell, index) => {
        const alignment = alignments[index] || 'left';
        tableHtml += `<th class="table-align-${alignment}">${cell.trim()}</th>`;
      });
      tableHtml += '</tr></thead>';

      // 添加表格体（从第三行开始）
      if (rows.length > 2) {
        tableHtml += '<tbody>';
        for (let i = 2; i < rows.length; i++) {
          const cells = rows[i].split('|').filter(cell => cell.trim() !== '');
          if (cells.length > 0) {
            tableHtml += '<tr>';
            cells.forEach((cell, index) => {
              const alignment = alignments[index] || 'left';
              tableHtml += `<td class="table-align-${alignment}">${cell.trim()}</td>`;
            });
            tableHtml += '</tr>';
          }
        }
        tableHtml += '</tbody>';
      }

      tableHtml += '</table></div>';
      console.log('生成的表格HTML:', tableHtml);
      return tableHtml;
    });
  },
  br: content => {
    // 只在非代码块区域处理换行
    return content.replace(/(\n)(?!(?:[^`]*`[^`]*`)*[^`]*```)/g, '<br/>');
  },
 // ========== 极简版 think 处理器（用于验证）==========
  think: (content) => {
    console.log('🚀 [Think处理器] 被调用了！输入长度:', content?.length);
    
    if (!content) return content;
    
    // 最简单粗暴的方式：直接替换所有 <think> 标签
    let result = content;
    result = result.replace(/<think>[\s\S]*?<\/think>/gi, '');
    result = result.trim();
    
    if (result !== content) {
      console.log('✅ [Think处理器] 过滤成功！');
      console.log('   原始:', content.substring(0, 100));
      console.log('   过滤后:', result.substring(0, 100));
    }
    
    return result;
  },   
  emphasis: content => {
    // 处理加粗 **文字** 或 __文字__
    content = content.replace(/\*\*(.*?)\*\*|__(.*?)__/g, '<strong>$1$2</strong>');

    // 处理斜体 *文字* 或 _文字_
    content = content.replace(/\*(.*?)\*|_(.*?)_/g, '<em>$1$2</em>');

    // 处理删除线 ~~文字~~
    content = content.replace(/~~(.*?)~~/g, '<del>$1</del>');

    // 处理下划线 ++文字++（自定义）
    content = content.replace(/\+\+(.*?)\+\+/g, '<u>$1</u>');

    // 处理高亮 ==文字==（自定义）
    content = content.replace(/==(.*?)==/g, '<mark>$1</mark>');

    return content;
  },
  // 添加标题处理器
  heading: content => {
    console.log('标题处理器开始处理');

    // 方法1：分步骤处理
    const lines = content.split('\n');
    let result = '';

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];

      // 检测标题行
      const headingMatch = line.match(/^\s*(#{1,6})\s+(.+)$/);
      if (headingMatch) {
        const level = headingMatch[1].length;
        const text = headingMatch[2];
        console.log(`找到标题行: level=${level}, text=${text}`);
        result += `<h${level} class="markdown-heading">${text}</h${level}>\n`;
      } else {
        result += line + '\n';
      }
    }

    console.log('标题处理器处理完成');
    return result;
  },
  list: content => {
    const lines = content.split('\n');
    let result = '';
    let currentListItems = [];
    let inList = false;

    const closeList = () => {
      if (currentListItems.length > 0) {
        result += `<ul class="markdown-list">${currentListItems.map(item => `<li>${item}</li>`).join('')}</ul>`;
        currentListItems = [];
      }
      inList = false;
    };

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();

      // 检测无序列表项
      if (line.startsWith('- ') || line.startsWith('* ')) {
        if (!inList) {
          inList = true;
        }
        currentListItems.push(line.substring(2).trim());
      }
      // 非列表内容
      else {
        closeList();
        result += lines[i] + '\n';
      }
    }

    // 处理末尾的列表
    closeList();

    return result;
  },
  flowchart: content => {
    console.log('=== 流程图处理器（修复版）===');
    console.log('输入内容预览:', content.substring(0, 500));
    
    // 修复正则：允许标题后直接跟箭头，或者有空白字符
    // 关键修改：将 [^→]+ 改为 [^→]*（零个或多个，而不是一个或多个）
    const result = content.replace(/(\[flowchart\]([\s\S]*?)\[\/flowchart\]|【([^】]+)】[^→]*(→[^→\n\r]+(?:\s*→\s*[^→\n\r]+)*))/g, 
    (match/*, fullMatch1, blockContent, title, stepsWithArrow*/) => {
      console.log('✅ 匹配到流程图内容:', match.substring(0, 200));
      
      if (match.startsWith('[flowchart]')) {
        console.log('检测到块格式流程图');
        return parseBlockFlowchart(match);
      } else {
         // 行格式用新的紧凑型
      const titleMatch = match.match(/【([^】]+)】/);
      const title = titleMatch ? titleMatch[1] : '业务流程';
      const steps = match.replace(/【[^】]+】/, '').split('→').map(step => step.trim());
      return generateCompactFlowchartHTML(title, steps);
      }
    });
    
    console.log('处理结果预览:', result.substring(0, 500));
    console.log('内容是否变化:', result !== content ? '✅ 已变化' : '❌ 未变化');
    console.log('=== 流程图处理器结束 ===');
    return result;
  },
  link: content => {
    if (!content) return content;
    
    // 如果已经是 HTML 链接，直接返回
    if (/<a\s+[^>]*href=["'][^"']*["']/i.test(content)) {
      return content;
    }

    // 先把图片语法占位保护起来，避免被普通链接正则误伤
    const imagePlaceholders = [];
    let protectedContent = content.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, (m) => {
      const idx = imagePlaceholders.length;
      imagePlaceholders.push(m);
      return `__IMG_PLACEHOLDER_${idx}__`;
    });

    // 处理普通 Markdown 链接
    protectedContent = protectedContent.replace(
      /\[([^\]]+)\]\(([^)]+)\)/g,
      '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
    );

    // 处理纯 URL 链接
    protectedContent = protectedContent.replace(
      /(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/g,
      (match, url) => {
        let cleanUrl = url;
        if (!cleanUrl.startsWith('http')) {
          cleanUrl = 'https://' + cleanUrl.replace(/^www\./, '');
        }
        return `<a href="${cleanUrl}" target="_blank" rel="noopener noreferrer">${url}</a>`;
      }
    );

    // 还原图片语法
    protectedContent = protectedContent.replace(/__IMG_PLACEHOLDER_(\d+)__/g, 
      (_, idx) => imagePlaceholders[Number(idx)]
    );

    return protectedContent;
  },

  bold: content => content.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
}


export const createCodeProcessor = (highlightFn) => ({
  code: content => content.replace(/```(\w*)([\s\S]*?)```/g,
    (_, lang, code) => {
      const codeId = 'code-' + Math.random().toString(36).slice(2, 9);

      // 移除代码中可能存在的 <br/> 标签（修复问题）
      const cleanCode = code.trim().replace(/<br\/>/g, '\n');
      
      // 关键修复：使用正确的换行处理
      const highlighted = highlightFn(lang, cleanCode);

      return `
        <div class="code-block">
          <div class="code-header">
            <span class="code-lang">${lang || 'text'}</span>
            <button class="copy-btn" data-code-id="${codeId}">

              <a class="copy-text" style="color:#474747">复制</a>
            </button>
          </div>
          <pre id="${codeId}"><code class="hljs language-${lang || 'text'}">${highlighted}</code></pre>
        </div>
      `;
    }
  )
});

export const imageProcessorAsync = async (content) => {
  if (!content) return content;

  const matches = content.match(/!\[([^\]]*)\]\(([^)]+)\)/g);
  if (!matches) return content;

  let result = content;

  for (const match of matches) {
    const m = match.match(/!\[([^\]]*)\]\(([^)]+)\)/);
    if (!m) continue;
    const [, alt, src] = m;
    if (!src) continue;

    console.log(`🖼️ 处理图片: ${src}`);

    // 已经是完整 http URL，直接转 img
    if (/^https?:\/\//i.test(src)) {
      result = result.replace(match,
        `<img src="${src}" alt="${alt || '图片'}" class="markdown-image ai-image" loading="lazy" />`);
      continue;
    }

    // 相对路径：调后端换签名 URL
    try {
      const response = await getTempImageUrl(src);
      // 你的 http 封装返回格式可能是 { code, data } 或 axios response
      const signedUrl = response?.data?.data || response?.data || response?.data?.url;
      
      if (signedUrl && typeof signedUrl === 'string') {
        result = result.replace(match,
          `<img src="${signedUrl}" alt="${alt || '图片'}" class="markdown-image ai-image" loading="lazy" />`);
        console.log(`✅ 签名 URL: ${signedUrl.substring(0, 80)}...`);
      } else {
        console.warn('⚠️ 返回数据里没有 URL:', response);
        // 降级：用 data-original-src 标记，交给后续处理
        result = result.replace(match,
          `<img src="" data-original-src="${src}" alt="${alt || '图片'}" class="markdown-image ai-image" />`);
      }
    } catch (error) {
      console.error('❌ 获取临时 URL 失败:', src, error);
      result = result.replace(match,
        `<img src="" data-original-src="${src}" alt="${alt || '图片'}" class="markdown-image ai-image" />`);
    }
  }

  return result;
};